import script from "./Govid.vue?vue&type=script&setup=true&lang=js"
export * from "./Govid.vue?vue&type=script&setup=true&lang=js"

import "./Govid.vue?vue&type=style&index=0&id=cce1b52c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cce1b52c"]])

export default __exports__